import { useMemo, useState } from 'react';
import Button from '../../components/Button/Button';
import Checkbox from '../../components/Inputs/Checkbox/Checkbox';
import PDF from '../../components/Pdf';

const ROLE_LABEL = { seller: 'ÐÑÐ¾Ð´Ð°Ð²ÐµÑ', buyer: 'ÐÐ¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ', agent: 'ÐÐ³ÐµÐ½Ñ' };

// Ð¡ÑÑÐ°Ð½Ð¸ÑÐ° Ð¿ÑÐ±Ð»Ð¸ÑÐ½Ð°Ñ, Ð° pdf Ð¸ sign Ð¿ÑÐ¸ÑÐ¾Ð´ÑÑ Ð¸Ð· Ð°Ð´ÑÐµÑÐ½Ð¾Ð¹ ÑÑÑÐ¾ÐºÐ¸. ÐÐµÐ· Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸
// Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ Ð»ÑÐ±Ð¾Ð¹ Ð¼Ð¾Ð³ Ð±Ñ ÑÐ¾Ð±ÑÐ°ÑÑ ÑÑÑÐ»ÐºÑ Ð½Ð° Ð½Ð°Ñ Ð´Ð¾Ð¼ÐµÐ½, ÐºÐ¾ÑÐ¾ÑÐ°Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ
// ÑÑÐ¶Ð¾Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð¸ ÑÐ²Ð¾Ð´Ð¸Ñ Â«Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ²Ð°ÑÑÂ» Ð½Ð° ÑÐ²Ð¾Ð¹ ÑÐ°Ð¹Ñ. Ð¡ÑÑÐ»ÐºÐ¸ Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ
// Ð²ÑÐ¿ÑÑÐºÐ°ÐµÑ Ð±ÑÐºÐµÐ½Ð´ Ð¸ ÐºÐ»Ð°Ð´ÑÑ Ð¸Ñ Ð½Ð° APP_URL (ÑÐ¾ÐºÑÐ°ÑÐ°ÑÐµÐ»Ñ) â ÑÐ¾Ð»ÑÐºÐ¾ ÐµÐ³Ð¾ Ð¸ Ð¿ÑÑÐºÐ°ÐµÐ¼.
export const parseOrigins = (...values) =>
  values
    .filter(Boolean)
    .flatMap((value) => String(value).split(','))
    .map((value) => {
      try {
        return new URL(String(value).trim()).origin;
      } catch {
        return null;
      }
    })
    .filter(Boolean);

const ALLOWED_ORIGINS = parseOrigins(process.env.REACT_APP_API_URL, process.env.REACT_APP_SIGN_ORIGINS);

// ÐÑÐºÐ°Ð· Ð·Ð´ÐµÑÑ ÑÐ°ÑÐµ Ð²ÑÐµÐ³Ð¾ Ð¾Ð·Ð½Ð°ÑÐ°ÐµÑ Ð½Ðµ Ð°ÑÐ°ÐºÑ, Ð° ÑÐ°Ð·ÑÐµÑÐ°Ð²ÑÑÑÑÑ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÑ:
// ÑÑÑÐ»ÐºÐ¸ ÑÐ¾Ð±Ð¸ÑÐ°ÐµÑ Ð±ÑÐºÐµÐ½Ð´ Ð¸Ð· APP_URL Ð¸ APP_URL_LOCAL, Ð° ÑÐ¿Ð¸ÑÐ¾Ðº â Ð¸Ð·
// REACT_APP_API_URL. ÐÐ¾Ð»ÑÐ° ÑÐ¾Ð½ÑÑÑ ÑÑÑÐ»ÐºÑ Ð½ÐµÐ»ÑÐ·Ñ, Ð¸Ð½Ð°ÑÐµ Ð¿Ð¾Ð»ÑÑÐ°ÑÐµÐ»Ñ Ð¡ÐÐ¡ Ð²Ð¸Ð´Ð¸Ñ
// Â«Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð°Â», Ð¸ Ð² Ð»Ð¾Ð³Ð°Ñ Ð½Ð¸ ÑÐ»ÐµÐ´Ð°.
export const safeUrl = (value, field, allowed = ALLOWED_ORIGINS) => {
  let url;
  try {
    url = new URL(String(value || ''));
  } catch {
    if (value) console.warn(`signTripartite: ${field} â Ð½Ðµ Ð°Ð±ÑÐ¾Ð»ÑÑÐ½ÑÐ¹ url`, value);
    return '';
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') {
    console.warn(`signTripartite: ${field} â Ð·Ð°Ð¿ÑÐµÑÑÐ½Ð½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¾ÐºÐ¾Ð»`, url.protocol);
    return '';
  }
  if (!allowed.includes(url.origin)) {
    console.warn(
      `signTripartite: ${field} â origin ${url.origin} Ð½Ðµ Ð² ÑÐ¿Ð¸ÑÐºÐµ ÑÐ°Ð·ÑÐµÑÑÐ½Ð½ÑÑ`,
      allowed,
      'Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ REACT_APP_API_URL / REACT_APP_SIGN_ORIGINS Ð¿ÑÐ¾ÑÐ¸Ð² APP_URL Ð¸ APP_URL_LOCAL Ð½Ð° Ð±ÑÐºÐµ'
    );
    return '';
  }
  return url.href;
};

const SignTripartite = () => {
  const state = useMemo(() => {
    try {
      const raw = new URLSearchParams(window.location.search).get('state');
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }, []);
  const [agree, setAgree] = useState(false);
  const pdf = safeUrl(state.pdf, 'pdf');
  const sign = safeUrl(state.sign, 'sign');
  const role = ROLE_LABEL[state.role] || '';

  if (!pdf || !sign) {
    const rejected = Boolean(state.pdf || state.sign);
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <h1>Ð¡ÑÑÐ»ÐºÐ° Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð°</h1>
        <p>ÐÐ¾Ð¿ÑÐ¾ÑÐ¸ÑÐµ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡ ÐµÑÑ ÑÐ°Ð·.</p>
        {rejected ? (
          <p style={{ color: '#667' }}>Ð¡ÑÑÐ»ÐºÐ° Ð²ÑÐ´Ð°Ð½Ð° Ð´ÑÑÐ³Ð¸Ð¼ Ð°Ð´ÑÐµÑÐ¾Ð¼ â Ð½Ð°Ð·Ð¾Ð²Ð¸ÑÐµ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ ÐºÐ¾Ð´ ORIGIN.</p>
        ) : null}
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '0 15px',
        width: '100%',
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <h1 style={{ margin: '20px 0' }}>
        ÐÐ½Ð¸Ð¼Ð°ÑÐµÐ»ÑÐ½Ð¾ Ð¾Ð·Ð½Ð°ÐºÐ¾Ð¼ÑÑÐµÑÑ Ñ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ¾Ð¼ Ð¸ Ð¿ÐµÑÐµÐ¹Ð´Ð¸ÑÐµ Ðº Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ
      </h1>
      {role ? (
        <p style={{ margin: '0 0 12px', color: '#667' }}>
          ÐÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÑÐ²Ð°ÐµÑÐµ ÐºÐ°Ðº {role}
          {state.name ? `: ${state.name}` : ''}
        </p>
      ) : null}
      <a href={pdf} target="_blank" rel="noreferrer" style={{ marginBottom: 12 }}>
        ÐÑÐºÑÑÑÑ PDF
      </a>
      <div style={{ position: 'relative', flex: 1, overflow: 'auto', minHeight: 320 }}>
        <PDF url={pdf} />
      </div>
      <div style={{ marginTop: 20 }}>
        <Checkbox
          id="agree"
          value={agree}
          onChange={(id, value) => setAgree(value)}
          label="ÐÐ·Ð½Ð°ÐºÐ¾Ð¼Ð»ÐµÐ½ Ð¸ ÑÐ¾Ð³Ð»Ð°ÑÐµÐ½ Ñ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ¾Ð¼"
        />
      </div>
      <div style={{ margin: '20px 0' }}>
        <Button
          fill
          full
          text="ÐÐµÑÐµÐ¹ÑÐ¸ Ðº Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ"
          disabled={!agree}
          onClick={() => {
            window.location.href = sign;
          }}
        />
      </div>
    </div>
  );
};

export default SignTripartite;
